'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function SJFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-gqlxapgi0", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-71pnt41kq", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-z7hye30s5" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-z7hye30s5", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-gqlxapgi0)" }, /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-z7hye30s5" }), /* @__PURE__ */ React.createElement("g", { fill: "#2e42a5", stroke: "#f7fcff", strokeWidth: "2", mask: "url(#mantine-71pnt41kq)" }, /* @__PURE__ */ React.createElement("path", { d: "M15-1V9h18v6H15v10H9V15H-1V9H9V-1z" }))))
  );
}

export { SJFlag };
//# sourceMappingURL=SJ.mjs.map
